import t from "react";
import { useTheme as l, Drawer as m, Stack as n, Typography as d, Box as u } from "@mui/material";
import { B as c } from "./chunk.CZnfKE1G.js";
import { B as i } from "./chunk.hFvqNSIf.js";
const k = (e) => {
  const o = l();
  return /* @__PURE__ */ t.createElement(
    m,
    {
      anchor: "right",
      open: e.open,
      hideBackdrop: e == null ? void 0 : e.hideBackdrop,
      PaperProps: {
        sx: {
          maxWidth: "25%",
          minWidth: "256px"
        }
      },
      onClose: (a, r) => e.onClose(a, r)
    },
    /* @__PURE__ */ t.createElement(
      n,
      {
        height: "100%",
        gap: 3,
        justifyContent: "space-between",
        p: o.spacing(3)
      },
      /* @__PURE__ */ t.createElement(n, { gap: 3 }, /* @__PURE__ */ t.createElement(n, { direction: "row", gap: 2, justifyContent: "space-between" }, /* @__PURE__ */ t.createElement(n, { alignItems: "center", gap: 2, direction: "row" }, e.onBack && /* @__PURE__ */ t.createElement(
        c,
        {
          icon: "arrow_back",
          onClick: e.onBack,
          "aria-label": "backButton"
        }
      ), /* @__PURE__ */ t.createElement(d, { variant: "subtitle200" }, e.title)), /* @__PURE__ */ t.createElement(
        c,
        {
          icon: "close",
          onClick: (a) => e.onClose(a, "closeButtonClicked"),
          "aria-label": "closeButton"
        }
      )), e.content && /* @__PURE__ */ t.createElement(u, null, e.content)),
      (e.primaryAction || e.secondaryAction) && /* @__PURE__ */ t.createElement(n, { direction: "row", gap: 1 }, e.primaryAction && /* @__PURE__ */ t.createElement(i, { ...e.primaryAction, variant: "contained", fullWidth: !0 }), e.secondaryAction && /* @__PURE__ */ t.createElement(i, { ...e.secondaryAction, variant: "outlined", fullWidth: !0 }))
    )
  );
};
export {
  k as S
};
